import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {
  ASSET_CONDITION_OPTIONS,
  newDesignInputCustomClassesViewOnly,
  TANGIBLE_ASSETS_CATEGORY
} from "../../../constants";
import {choiceValue, dateToMoment, momentToDate} from "../../utils";


const TangibleForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    sub_category: choiceValue(defaults.sub_category),
    name: defaults.name,
    brand_or_manufacture: defaults.brand_or_manufacture,
    value: decimalStrToNumber(defaults.value),
    produce_date: dateToMoment(defaults.produce_date),
    value_date: dateToMoment(defaults.value_date),
    purchase_amount: decimalStrToNumber(defaults.purchase_amount),
    purchase_date: dateToMoment(defaults.purchase_date),
    condition: choiceValue(defaults.condition),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      value_date: momentToDate(model.value_date),
      purchase_date: momentToDate(model.purchase_date),
      produce_date: momentToDate(model.produce_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <SelectFormElementV2
            label="Kategorie"
            value={model.sub_category}
            options={TANGIBLE_ASSETS_CATEGORY.subCategories}
            onChange={handleModelChange('sub_category')}
            dataId={'category-input'}
            required
            newDesign
            disabled={viewOnly}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Marke / Hersteller / Künstler'}
          value={model.brand_or_manufacture}
          error={errors.brand_or_manufacture}
          onChange={handleModelChange('brand_or_manufacture')}
          dataId={'brand_or_manufacture-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Wert / Bewertung"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CalendarFormElement
          label="Bewertungsdatum"
          disableFuture
          value={model.value_date}
          error={errors.value_date}
          onChange={handleModelChange('value_date')}
          dataId={'value_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Kaufpreis"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.purchase_amount}
          error={errors.purchase_amount}
          onChange={handleModelChange('purchase_amount')}
          dataId={'purchase_amount-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Erwerbsdatum"
          value={model.purchase_date}
          error={errors.purchase_date}
          onChange={handleModelChange('purchase_date')}
          dataId={'acquisition_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Jahrgang / Baujahr"
          disableFuture
          yearOnly
          value={model.produce_date}
          error={errors.produce_date}
          onChange={handleModelChange('produce_date')}
          dataId={'produce_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectFormElementV2
          label="Zustand"
          value={model.condition}
          options={ASSET_CONDITION_OPTIONS}
          onChange={handleModelChange('condition')}
          dataId={'condition-input'}
          custom_classes={inputClasses}
          disabled={viewOnly}
          addEmptyOption
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

TangibleForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default TangibleForm;